import { useTranslation } from "react-i18next"
import { Switch } from "@/shadcn/components/ui/switch"
import { Input } from "@/shared/components/Input"
import type { MockRequestConfig } from "../model/types"

type MockRequestListItemProps = {
  request: MockRequestConfig
  onEnabledChange: (enabled: boolean) => void
  onResponseTagChange: (responseTag: string) => void
}

const METHOD_CLASS_NAME: Record<string, string> = {
  GET: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400",
  POST: "bg-sky-500/15 text-sky-700 dark:text-sky-400",
  PUT: "bg-amber-500/15 text-amber-700 dark:text-amber-400",
  PATCH: "bg-violet-500/15 text-violet-700 dark:text-violet-400",
  DELETE: "bg-red-500/15 text-red-700 dark:text-red-400",
}

export function MockRequestListItem({
  request,
  onEnabledChange,
  onResponseTagChange,
}: MockRequestListItemProps) {
  const { t } = useTranslation("mock-server")

  return (
    <li className="flex items-center gap-3 border-b border-border py-2.5 last:border-b-0">
      <Switch
        checked={request.enabled}
        onCheckedChange={onEnabledChange}
        aria-label={t("toggleRequest")}
        className="shrink-0"
      />
      <span
        className={`w-16 shrink-0 rounded-sm px-2 py-1 text-center font-mono text-xs font-semibold ${
          METHOD_CLASS_NAME[request.method.toUpperCase()] ?? "bg-muted text-muted-foreground"
        }`}
      >
        {request.method.toUpperCase()}
      </span>
      <p className="min-w-0 flex-1 truncate font-mono text-sm" title={request.path}>
        {request.path}
      </p>
      <Input
        value={request.responseTag}
        onChange={(event) => onResponseTagChange(event.target.value)}
        placeholder={t("responseTagPlaceholder")}
        clearable={true}
        className="w-50 shrink-0"
      />
    </li>
  )
}
